import { useEffect, useMemo, useState } from 'react'
import useCookie from 'src/hooks/useCookie'
import { useQueryUserInfo } from 'src/services/queries'
import { useQueryRuntimeConfig } from 'src/services/queries/useQueryRuntimeConfig'

const useLayout = () => {
  const { setCookie, value } = useCookie('isEmbedded')
  const [isEmbedded, setIsEmbedded] = useState(value === "true")
  const { data, } = useQueryRuntimeConfig()
  const { data: user } = useQueryUserInfo()

  const userEmail = useMemo(() => user.data?.email, [user.data?.email]);
  const usyncroEmail = useMemo(() => data.data?.USYNCRO_PARTNER?.email, [data.data?.USYNCRO_PARTNER?.email]);

  useEffect(() => {
    if (userEmail === usyncroEmail) {
      setIsEmbedded(true)
      setCookie("true")
    } else {
      setCookie("false")
    }
  }, [userEmail, usyncroEmail])

  return { isEmbedded }
}

export default useLayout